import { getToken } from "../redux/reducers/auth";

/**
 * Decodes JWT token to extract MFA attributes
 */
const decodeJWTForMFAAttributes = (token: string): { mfaEnabled: boolean; mfaStatus: "SETUP" | "NOT_SETUP" } => {
  try {
    const tokenData: any = JSON.parse(atob(token.split(".")[1]));
    return {
      mfaEnabled: tokenData["custom:enableMFA"] === "true",
      mfaStatus: tokenData["custom:mfaStatus"] === "SETUP" ? "SETUP" : "NOT_SETUP",
    };
  } catch (error) {
    console.error("Error decoding JWT for MFA attributes:", error);
    // Return default values if decoding fails
    return {
      mfaEnabled: false,
      mfaStatus: "NOT_SETUP",
    };
  }
};

/**
 * Gets MFA state from JWT token
 */
export const getMFAStateFromToken = (): { mfaEnabled: boolean; mfaStatus: "SETUP" | "NOT_SETUP" } => {
  const token = getToken();
  return decodeJWTForMFAAttributes(token);
};